import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SnoozeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"snooze"}/>
}
